var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#089CFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1673 15.0003V19.5837C24.1673 22.3337 22.334 24.167 19.584 24.167H10.4173C7.66732 24.167 5.83398 22.3337 5.83398 19.5837V15.0003C5.83398 12.507 7.33732 10.7653 9.67482 10.472C9.91315 10.4353 10.1607 10.417 10.4173 10.417H19.584C19.8223 10.417 20.0515 10.4261 20.2715 10.4628C22.6365 10.7378 24.1673 12.4887 24.1673 15.0003Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2724 10.4622C20.0524 10.4255 19.8233 10.4164 19.5849 10.4164H10.4183C10.1616 10.4164 9.91411 10.4347 9.67578 10.4713C9.80411 10.2147 9.98745 9.97635 10.2074 9.75635L13.1866 6.76801C14.4424 5.52134 16.4774 5.52134 17.7333 6.76801L19.3374 8.39053C19.9241 8.96803 20.2358 9.70134 20.2724 10.4622Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1673 15.458H21.4173C20.409 15.458 19.584 16.283 19.584 17.2913C19.584 18.2997 20.409 19.1247 21.4173 19.1247H24.1673",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/Cart.86e61b36266977d137f0c997b313df96.svg";
export { ForwardRef as ReactComponent };